import React from 'react';
import { useTenantAuth } from '../../context/TenantAuthContext';

/**
 * Renders children only if the current tenant user has the given permission code.
 */
export function TenantCan({ permission, anyOf, children, fallback = null }) {
  const { hasPermission, ready } = useTenantAuth();
  if (!ready) return null;
  if (anyOf && Array.isArray(anyOf)) {
    if (anyOf.some((p) => hasPermission(p))) return children;
    return fallback;
  }
  if (permission && hasPermission(permission)) return children;
  return fallback;
}
